import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { FilterItem } from '../api/_generated_';
import { ATTRIBUTE_OPTIONS } from '../constants/queryKeys';
import useAxiosPrivate from './useAxiosPrivate';

type Props = {
  attributeCode: string;
};

export default function useAttributeOptions({
  attributeCode,
}: Props) {
  const { i18n } = useTranslation();

  const axios = useAxiosPrivate();

  async function queryFn() {
    const res = await axios.get<FilterItem[]>(`/attributes/${attributeCode}/options?locale=${i18n.language}`);
    return res.data;
  }

  return useQuery({
    queryKey: [ATTRIBUTE_OPTIONS, attributeCode, i18n.language],
    queryFn,
    staleTime: Infinity,
  });
}
